import { getCookie, chatSessionCookieKey, setState, getState } from './storageManager';
import Notification from './notification';
import injectTranscriptButton from './transcript';

let isWindowActive = true;
/**
 * TODO: I'm sorry; Hopefully a Genesys fix will resolve need for timeout here
 */
function toggleUserTyping(shouldEnable, timeout) {
  if (shouldEnable) {
    // Enable client ability to type in Chat
    setTimeout(() => {
      const msgInputTextArea = document.getElementsByClassName('cx-message-input')[0];
      if (msgInputTextArea) {
        msgInputTextArea.disabled = false;
        msgInputTextArea.placeholder = 'Type your message here';
      }
    }, timeout);
  } else {
    // Disable client ability to type in chat
    setTimeout(() => {
      const msgInputTextArea = document.getElementsByClassName('cx-message-input')[0];
      if (msgInputTextArea) {
        msgInputTextArea.disabled = true;
        msgInputTextArea.placeholder = '';
      }
    }, timeout);
  }
}

function registerChatChannelEvents(userId) {
  window.onfocus = () => {
    isWindowActive = true;
  };
  window.onblur = () => {
    isWindowActive = false;
  };
  const CXBus = window._genesys.widgets.bus;
  let isChatRestoring = false;

  CXBus.subscribe('WebChat.opened', () => {
    window.dispatchEvent(
      new CustomEvent('chat.opened', {
        detail: {
          subject: 'chat',
          subTopic: 'chatwindow',
        },
      }),
    );
    const { transcriptsEnabled } = getState();
    if (isChatRestoring && transcriptsEnabled) {
      injectTranscriptButton(userId);
    }
  });

  CXBus.subscribe('WebChat.started', () => {
    toggleUserTyping(false, 0);

    window.dispatchEvent(
      new CustomEvent('chat.started', {
        detail: {
          subject: 'chat',
          subTopic: 'chatstart',
          value: getCookie(chatSessionCookieKey),
        },
      }),
    );
  });

  CXBus.subscribe('WebChat.completed', () => {
    setState({
      transcriptsEnabled: null,
      transcriptRequestSucceeded: null,
    });
    isChatRestoring = false;
    const chatSurveyLink = getCookie('chatSurveyLink');
    if (chatSurveyLink) {
      const surveyLinkText = `Thank you for contacting Travelers, click here to rate your experience: ${chatSurveyLink}`;
      window._genesys.widgets.bus.command('WebChat.injectMessage', {
        type: 'text',
        text: surveyLinkText,
      });
    }
    window.dispatchEvent(
      new CustomEvent('chat.completed', {
        detail: {
          subject: 'chat',
          subTopic: 'chatend',
          value: getCookie(chatSessionCookieKey),
        },
      }),
    );
  });

  // No longer a requirement for this tag
  CXBus.subscribe('WebChat.cancelled', () => {
    window.dispatchEvent(
      new CustomEvent('chat.cancelled', {
        detail: {
          subject: 'chat',
          subTopic: 'chatcancel',
          value: getCookie(chatSessionCookieKey), // TODO: no session here?
        },
      }),
    );
  });

  CXBus.subscribe('WebChat.closed', () => {
    setState({ chatSessionId: null });
    window.dispatchEvent(
      new CustomEvent('chat.closed', {
        detail: {
          subject: 'chat',
          subTopic: 'chatclose',
        },
      }),
    );
  });

  CXBus.subscribe('WebChat.messageAdded', () => {
    // check the bowser tab is active and highlight if not
    if (!isWindowActive) {
      Notification.notifyTab();
    }
  });

  CXBus.subscribe('WebChatService.agentConnected', () => {
    toggleUserTyping(true, 1000);
    if (
      !isChatRestoring &&
      window.channelsConfig.chat &&
      window.channelsConfig.chat.enableTranscript
    ) {
      injectTranscriptButton(userId);

      setState({
        chatSessionId: getCookie(chatSessionCookieKey),
        transcriptsEnabled: window.channelsConfig.chat.enableTranscript,
      });
    }
  });

  CXBus.subscribe('WebChatService.restored', () => {
    // Restrict text input until agent connected
    toggleUserTyping(false, 1000);
    isChatRestoring = true;
  });
}

function registerCobrowseChannelEvents(cobrowseAPI) {
  if (cobrowseAPI) {
    let cobrowseId;
    let subject;

    // triggers when customer starts cobrowse and session id is generated
    cobrowseAPI.onSessionStarted.add(details => {
      const subTopic = 'cust_connect';
      cobrowseId = details.token;
      subject = details.widgetOrigin === 'WebChat' ? 'chat_cobrowse' : 'phone_cobrowse';
      window.dispatchEvent(
        new CustomEvent('cobrowse.started', {
          detail: {
            subject,
            subTopic,
            value: cobrowseId,
          },
        }),
      );
    });

    // triggers when ISR joins the cobrowse session
    cobrowseAPI.onAgentJoined.add((agent, session) => {
      cobrowseId = session.token;
      window.dispatchEvent(
        new CustomEvent('cobrowse.agentJoined', {
          detail: {
            subject,
            subTopic: 'isr_connect',
            value: cobrowseId,
          },
        }),
      );
    });

    // triggers when cobrowse session is disconnected
    cobrowseAPI.onSessionEnded.add(details => {
      const subTopic = details.reason === 'self' ? 'disconnect_cust' : 'disconnect';
      window.dispatchEvent(
        new CustomEvent('cobrowse.ended', {
          detail: {
            subject,
            subTopic,
            value: cobrowseId,
          },
        }),
      );
    });
  }
}

function dispatchChannelsListeners() {
  window.dispatchEvent(
    new CustomEvent('channels.events', {
      detail: [
        { eventName: 'chat.opened', tagType: 'meta' },
        { eventName: 'chat.started', tagType: 'meta' },
        { eventName: 'chat.completed', tagType: 'meta' },
        { eventName: 'chat.cancelled', tagType: 'meta' },
        { eventName: 'chat.closed', tagType: 'meta' },
        { eventName: 'chat.linkClicked', tagType: 'click' },
        { eventName: 'chat.linkInserted', tagType: 'meta' },
        { eventName: 'chat.eligibility', tagType: 'meta' },
        { eventName: 'cobrowse.started', tagType: 'meta' },
        { eventName: 'cobrowse.linkClicked', tagType: 'click' },
        { eventName: 'cobrowse.agentJoined', tagType: 'meta' },
        { eventName: 'cobrowse.ended', tagType: 'meta' },
      ],
    }),
  );
}

export { registerCobrowseChannelEvents, registerChatChannelEvents, dispatchChannelsListeners };
